import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Form, Input, Button, Checkbox, Card, Typography, Space } from 'antd'
import { UserOutlined, LockOutlined } from '@ant-design/icons'
import { showError } from '../utils/notificationUtils'
import './Login.css'

const { Title, Text } = Typography

interface LoginProps {
  onLogin: (
    email: string,
    password: string,
    remember?: boolean
  ) => Promise<boolean>
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const navigate = useNavigate()
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)

  const onFinish = async (values: {
    email: string
    password: string
    remember: boolean
  }) => {
    const { email, password, remember } = values
    setIsSubmitting(true)

    try {
      const success = await onLogin(email, password, remember)
      if (success) {
        // Lưu trạng thái remember để authService sử dụng
        localStorage.setItem('remember_login', remember ? 'true' : 'false')
        navigate('/admin/dashboard')
      }
    } catch (err: any) {
      // Kiểm tra và hiển thị lỗi 401 từ API response nếu có
      if (err?.response?.status === 401) {
        const errorMessage =
          err?.response?.data?.message || 'Sai thông tin đăng nhập'
        showError('Đăng nhập thất bại', errorMessage)
      } else {
        showError(
          'Đăng nhập thất bại',
          err?.message || 'Đã xảy ra lỗi khi đăng nhập. Vui lòng thử lại sau.'
        )
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className='flex justify-center items-center p-4 min-h-screen login-container'>
      <Card className='w-full max-w-md shadow-md login-card'>
        <div className='mb-6 text-center'>
          <Title level={2} className='mb-1'>
            Quản lý DeSilk
          </Title>
          <Text type='secondary'>Đăng nhập để quản lý DeSilk</Text>
        </div>

        <Form
          name='login'
          initialValues={{
            remember: false
          }}
          onFinish={onFinish}
          layout='vertical'
          requiredMark={false}
          size='large'
        >
          <Form.Item
            name='email'
            rules={[
              { required: true, message: 'Vui lòng nhập email!' },
              { type: 'email', message: 'Email không hợp lệ!' }
            ]}
          >
            <Input
              prefix={<UserOutlined className='text-gray-400' />}
              placeholder='Email'
              autoComplete='email'
            />
          </Form.Item>

          <Form.Item
            name='password'
            rules={[{ required: true, message: 'Vui lòng nhập mật khẩu!' }]}
          >
            <Input.Password
              prefix={<LockOutlined className='text-gray-400' />}
              placeholder='Mật khẩu'
              autoComplete='current-password'
            />
          </Form.Item>

          <div className='flex justify-between items-center mb-4'>
            <Form.Item name='remember' valuePropName='checked' noStyle>
              <Checkbox>Ghi nhớ đăng nhập</Checkbox>
            </Form.Item>
                            <a className='text-black hover:text-gray-700' href='#'>
                  Quên mật khẩu?
                </a>
          </div>

          <Form.Item>
            <Button
              type='primary'
              htmlType='submit'
              className='w-full'
              loading={isSubmitting}
            >
              {isSubmitting ? 'Đang đăng nhập...' : 'Đăng nhập'}
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  )
}

export default Login
